import { axiosWithAuth } from '../api/interceprots'

/** Элемент GET /devices. hwid бэкенд не отдаёт — устройство опознаётся по ОС/модели/метке. */
export interface Device {
	id: number
	device_os: string
	ver_os: string
	device_model: string
	label: string | null
	first_seen: string
	last_seen: string
}

/** limit === 0 → лимит устройств выключен (не показываем счётчик/предупреждения). */
export interface DevicesResponse {
	items: Device[]
	limit: number
}

export const DevicesService = {
	async getDevices() {
		const response = await axiosWithAuth.get<DevicesResponse>('devices')
		return response.data
	},
	async unlinkDevice(id: number) {
		const response = await axiosWithAuth.delete<{ id: number }>(`devices/${id}`)
		return response.data
	},
}
